import { DepartmentsService } from "@common/client"
import { makeAxiosMutation, makeNoArgsQuery, makeQuery } from "./utils"

export const departmentsBaseKey = ["departments"] as const

export const departmentsQuery = makeNoArgsQuery({
  serviceCall: DepartmentsService.listDepartments,
  queryKey: departmentsBaseKey,
})

export const useCreateDepartmentMutation = makeAxiosMutation({
  serviceCall: DepartmentsService.create,
  invalidates: () => [departmentsBaseKey],
})

export const useUpdateDepartmentMutation = makeAxiosMutation({
  serviceCall: DepartmentsService.update,
  invalidates: () => [departmentsBaseKey],
})

export const useDeleteDepartmentMutation = makeAxiosMutation({
  serviceCall: DepartmentsService.delete,
  invalidates: () => [departmentsBaseKey],
})

export const archivedDepartmentsQuery = makeNoArgsQuery({
  serviceCall: () => DepartmentsService.listDepartments({ deleted: true }),
  queryKey: [...departmentsBaseKey, "archived"],
})

export const departmentQuery = makeQuery({
  serviceCall: (id: string) =>
    DepartmentsService.get({ department_id: id, include_archived: true }),
  queryKey: (id) => [...departmentsBaseKey, "detail", id],
})

export const useRestoreDepartmentMutation = makeAxiosMutation({
  serviceCall: DepartmentsService.restore,
  invalidates: () => [departmentsBaseKey],
})
